import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TCommissionHistoryQuery } from '../helpers';
import {
  getCategoryCommissions,
  getCommissionHistoryFilters,
  getCommissionHistoryList,
  updateCategoryCommissions,
} from './actionCreators';
import { COMMISSION_SLICE_NAME, CommissionState, initialHistoryQuery, initialState } from './models';

export const slice = createSlice({
  name: COMMISSION_SLICE_NAME,
  initialState,
  reducers: {
    resetCommissionState() {
      return initialState;
    },
    changeHistoryQuery(state: CommissionState, action: PayloadAction<TCommissionHistoryQuery>) {
      state.historyQuery = action.payload;
    },
    resetHistoryQuery(state: CommissionState) {
      state.historyQuery = initialHistoryQuery;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryCommissions.fulfilled, (state: CommissionState, action) => {
        state.categories = action.payload.data;
        state.isLoading = false;
      })
      .addCase(getCommissionHistoryList.fulfilled, (state: CommissionState, action) => {
        state.historyList = action.payload.data;
        state.historyPagination = action.payload.meta;
        state.isHistoryListLoading = false;
      })
      .addCase(getCommissionHistoryFilters.fulfilled, (state: CommissionState, action) => {
        state.historyFilters = action.payload.data;
        state.isHistoryFiltersLoading = false;
      })
      .addCase(updateCategoryCommissions.fulfilled, (state: CommissionState) => {
        state.isSaving = false;
      })
      .addMatcher(isPending(getCategoryCommissions), (state: CommissionState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isPending(getCommissionHistoryList), (state: CommissionState) => {
        state.isHistoryListLoading = true;
        state.error = null;
      })
      .addMatcher(isPending(getCommissionHistoryFilters), (state: CommissionState) => {
        state.isHistoryFiltersLoading = true;
        state.error = null;
      })
      .addMatcher(isPending(updateCategoryCommissions), (state: CommissionState) => {
        state.isSaving = true;
        state.error = null;
      })
      .addMatcher(
        isRejected(
          getCategoryCommissions,
          getCommissionHistoryList,
          getCommissionHistoryFilters,
          updateCategoryCommissions,
        ),
        (state: CommissionState, action) => {
          state.isLoading = false;
          state.isSaving = false;
          state.isHistoryListLoading = false;
          state.isHistoryFiltersLoading = false;
          state.error = action.error;
          showApiErrors(action.error);
        },
      );
  },
});

export const { resetCommissionState, changeHistoryQuery, resetHistoryQuery } = slice.actions;

export default slice.reducer;
